<ng-container *ngIf="!isLoading && displayMessages.length > 0 then ShowMessages else ShowNoMessagesMessage"></ng-container>


<div *ngIf="isLoading" fxLayout="column" style="width: 94vw;" fxLayoutGap="10px">
    <app-skeleton-loading></app-skeleton-loading>
    <app-skeleton-loading></app-skeleton-loading>
    <app-skeleton-loading></app-skeleton-loading>
</div>

<ng-template #ShowMessages>
    <cdk-virtual-scroll-viewport itemSize="50" [style.height.px]="listHeight" style=" width: 94vw;">
        <div *cdkVirtualFor="let item of displayMessages"
             style="margin-top: 0.5rem; width: 94vw; margin-bottom: 0.5rem;display: flex; flex-direction: row;"
             (click)="preview(item.id)">
            <div fxLayout="column" fxLayoutGap="10px">

                <div fxLayout="row" style="font-size: 16px; font-weight: 600;" class="mobile-list-item-title">{{item.subject}}</div>
                <div fxLayout="row" style="font-size: 12px;">{{item.status}}</div>
                <div fxLayout="row" style="font-size: 12px;">Ημ. Δημοσίευσης: {{item.sent_date}}</div>

                <div style="height: 1px; width: 94vw; background-color: var(--secondaryBlue)"></div>
            </div>
        </div>
    </cdk-virtual-scroll-viewport>
</ng-template>
<ng-template #ShowNoMessagesMessage>
    <div fxLayout="column" style="width: 94vw;" [style.height.px]="listHeight" fxLayoutAlign="center center center">
        <label style="font-size: 18px; font-weight: 650">Δεν έχετε λάβει κάποιο προσωπικό μήνυμα</label>
    </div>
</ng-template>
